import {
  increaseSpeedFunction,
  decreaseSpeedFunction,
} from '../../../../../hooks/useChangeBallSpeedFunctions/useChangeBallSpeedFunctions';

export default function ChangeBallSpeed(inputValue: boolean) {
  if (inputValue) {
    increaseSpeedFunction();
  } else {
    decreaseSpeedFunction();
  }
}
